// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ReportsPage.module.css */

.ReportsPage_container__x0FcL {
  display: flex;
  flex-direction: column;           /* колонки: header, nav, main */
  height: calc(100vh - 145px);      /* высота под “header + nav” */
  background-color: #f5f5f5;
}

/* Шапка страницы */
.ReportsPage_header__IGpIm {
  background-color: #ffffff;
  padding: 1rem 2rem;
  border-bottom: 1px solid #ddd;
}

/* Название */
.ReportsPage_title__Yjh\\+b {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}

/* Навигация — строка сверху */
.ReportsPage_nav__L3N51 {
  display: flex;
  flex-shrink: 0;                   /* не обрезаемся по высоте */
  background-color: #fafafa;
  padding: 0.5rem 2rem;
  border-bottom: 1px solid #ddd;
  align-items: center;              /* выровнять кнопки по центру по вертикали */
  height: 48px;                     /* можно задать жёсткую высоту, например 48px */
}

/* Кнопки в навигации */
.ReportsPage_navButton__x8VVw {
  margin-right: 1rem;
  padding: 0.4rem 1rem;             /* чуть меньше padding, чтобы они не “растягивались” */
  background-color: #ffffff;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s, border-color 0.2s;
  white-space: nowrap;              /* не давать тексту переноситься внутри кнопки */
}

.ReportsPage_navButton__x8VVw:hover {
  background-color: #f0f0f0;
  border-color: #bbb;
}

.ReportsPage_navButton__x8VVw:active,
.ReportsPage_navButton__x8VVw.ReportsPage_active__\\+9Nzx {
  background-color: #e0e0e0;
  border-color: #999;
}

/* Основная область с отчётами */
.ReportsPage_content__GNbHo {
  flex: 1 1;                          /* занимает всё оставшееся место */
  padding: 2rem;
  overflow-x: auto;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Manager/ReportsPage/ReportsPage.module.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;EACE,aAAa;EACb,sBAAsB,YAAY,+BAA+B;EACjE,2BAA2B,OAAO,8BAA8B;EAChE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,aAAa;AACb;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,cAAc,oBAAoB,4BAA4B;EAC9D,yBAAyB;EACzB,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB,eAAe,4CAA4C;EAC9E,YAAY,sBAAsB,+CAA+C;AACnF;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,oBAAoB,cAAc,sDAAsD;EACxF,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oDAAoD;EACpD,mBAAmB,eAAe,gDAAgD;AACpF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,SAAO,2BAA2B,kCAAkC;EACpE,aAAa;EACb,gBAAgB;AAClB","sourcesContent":["/* ReportsPage.module.css */\r\n\r\n.container {\r\n  display: flex;\r\n  flex-direction: column;           /* колонки: header, nav, main */\r\n  height: calc(100vh - 145px);      /* высота под “header + nav” */\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n/* Шапка страницы */\r\n.header {\r\n  background-color: #ffffff;\r\n  padding: 1rem 2rem;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n/* Название */\r\n.title {\r\n  margin: 0;\r\n  font-size: 1.5rem;\r\n  color: #333;\r\n}\r\n\r\n/* Навигация — строка сверху */\r\n.nav {\r\n  display: flex;\r\n  flex-shrink: 0;                   /* не обрезаемся по высоте */\r\n  background-color: #fafafa;\r\n  padding: 0.5rem 2rem;\r\n  border-bottom: 1px solid #ddd;\r\n  align-items: center;              /* выровнять кнопки по центру по вертикали */\r\n  height: 48px;                     /* можно задать жёсткую высоту, например 48px */\r\n}\r\n\r\n/* Кнопки в навигации */\r\n.navButton {\r\n  margin-right: 1rem;\r\n  padding: 0.4rem 1rem;             /* чуть меньше padding, чтобы они не “растягивались” */\r\n  background-color: #ffffff;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  transition: background-color 0.2s, border-color 0.2s;\r\n  white-space: nowrap;              /* не давать тексту переноситься внутри кнопки */\r\n}\r\n\r\n.navButton:hover {\r\n  background-color: #f0f0f0;\r\n  border-color: #bbb;\r\n}\r\n\r\n.navButton:active,\r\n.navButton.active {\r\n  background-color: #e0e0e0;\r\n  border-color: #999;\r\n}\r\n\r\n/* Основная область с отчётами */\r\n.content {\r\n  flex: 1;                          /* занимает всё оставшееся место */\r\n  padding: 2rem;\r\n  overflow-x: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ReportsPage_container__x0FcL`,
	"header": `ReportsPage_header__IGpIm`,
	"title": `ReportsPage_title__Yjh+b`,
	"nav": `ReportsPage_nav__L3N51`,
	"navButton": `ReportsPage_navButton__x8VVw`,
	"active": `ReportsPage_active__+9Nzx`,
	"content": `ReportsPage_content__GNbHo`
};
export default ___CSS_LOADER_EXPORT___;
